/**
 * TrackEdit
 * 
 * @Author: Focci
 * @Date: 2023-08-17 14:36:10
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 14:36:10
 */

import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import TrackTitle from '../TrackTitle'
import TrackEditForm from './TrackEditForm'

export default function TrackEdit({
  param = {},
  property = {},
  onSubmit = () => {},
}) {
  const tt = useTranslations('track')

  return (
    <div>
      <TrackTitle label={tt('uploadPropertyImages')} />
      <div className="max-w-[25rem] mx-auto">
        <TrackEditForm 
          param={param} 
          propertyId={property.id}
          property={property}
          onSuccess={onSubmit}
        />
      </div>
    </div>
  )
}

TrackEdit.propTypes = {
  param: PropTypes.object,
  onSubmit: PropTypes.func,
  property: PropTypes.object,
}
